import type {ExtensionAPI} from '@wix/document-manager-core'

export interface AccessibilityExtensionAPI extends ExtensionAPI {
    accessibility: {
        visualFocus: {
            get(): boolean
            set(enabled: boolean): void
        }
        autoDomReorder: {
            get(): boolean
            set(enabled: boolean): void
        }
        skipToContent: {
            get(): boolean
            set(enabled: boolean): void
        }
        languageDirection: {
            isRTL(languageCode: string): boolean
            getSiteDirection(): string
            setSiteDirection(siteDirection: string): void
        }
    }
}

export type LanguageDirection = 'ltr' | 'rtl'

export const RTL_LANGUAGES = [
    'ar',
    'arc',
    'bcc',
    'bqi',
    'ckb',
    'dv',
    'fa',
    'glk',
    'ha',
    'he',
    'khw',
    'ks',
    'ku',
    'mzn',
    'pnb',
    'ps',
    'sd',
    'ug',
    'ur',
    'yi'
] as const

// View modes for reordering
export const VIEW_MODES = {
    DESKTOP: 'DESKTOP',
    MOBILE: 'MOBILE'
} as const

// Constants for accessibility settings
export const ACCESSIBILITY_SETTINGS_PATH = 'accessibilitySettings'
export const MASTER_PAGE_ID = 'masterPage'
